import { render, staticRenderFns } from "./Disclaimers.vue?vue&type=template&id=065f72dc&scoped=true&"
var script = {}
import style0 from "./Disclaimers.vue?vue&type=style&index=0&id=065f72dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f72dc",
  null
  
)

export default component.exports